<template>
    <div id="create-event-form">
        <div class="tags" v-if="Object.keys(eventDetail).length === 0">
            <span class="tag" :class="{ selected: selectedTag === 'event' }" @click="changeSelectedTag('event')">{{
                $t("calendar.event")
            }}</span>
            <span
                class="tag"
                :class="{ selected: selectedTag === 'task' }"
                @click="changeSelectedTag('task')"
                v-if="false"
                >{{ $t("calendar.legacyTaskTag") }}</span
            >
            <span
                v-if="false"
                class="tag"
                :class="{ selected: selectedTag === 'schedule' }"
                @click="changeSelectedTag('schedule')"
                >{{ $t("calendar.legacyAppointmentScheduleTag") }}</span
            >
        </div>
        <div class="event-infos" v-if="selectedTag === 'event'">
            <EventTag
                :eventSummary="eventSummary"
                :repeatTimes="repeatTimes"
                :visibilities="visibilities"
                :selectedStartDate="selectedStartDate"
                :selectedEndDate="selectedEndDate"
                :eventDetail="eventDetail"
                @close="$emit('close')"
                :event-function="editOrCreateEvent"
                @delete-event="deleteEvent($event)"
                :calendarList="cloneCalendarList"
                :refVisitor="refVisitor"
                :footerVisible="footerVisible"
            />
        </div>
        <div class="task-infos" v-if="selectedTag === 'task'">
            <TaskTag
                :repeatTimes="repeatTimes"
                :eventDetail="eventDetail"
                @close="$emit('close')"
                :event-function="editOrCreateEvent"
                @delete-event="deleteEvent($event)"
            />
        </div>
        <div class="task-infos" v-if="selectedTag === 'schedule'">
            <ScheduleTag />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
import { log2 } from "../../../../utils/log2";
import moment from "moment";
import TaskTag from "./TaskTag.vue";
import ScheduleTag from "./ScheduleTag.vue";
import EventTag from "./EventTag.vue";
import { sendSocketMessage } from "../../../../utils/socketStream";
import { CALENDAR_API } from "../../../../api/calendar";

moment.locale("tr");
const log = log2("CreateEventForm");
export default {
    name: "CreateEventForm",
    components: { EventTag, ScheduleTag, TaskTag },
    props: {
        footerVisible: {
            type: Boolean,
            default: true,
        },
        refVisitor: {
            type: String,
            default: "",
        },
        eventSummary: {
            type: String,
            default: "",
        },
        eventDetail: {
            type: Object,
            default: () => ({}),
        },
        selectedStartDate: {
            type: Date,
            default: () => new Date(),
        },
        selectedEndDate: {
            type: Date,
            default: () => moment().add(1, "hour").toDate(),
        },
        calendarList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            selectedTag: "event",
            repeatTimes: [
                {
                    label: this.$t("calendar.notRepeat"),
                    value: "not_repeat",
                },
                {
                    label: this.$t("calendar.daily"),
                    value: "daily",
                },
                {
                    label: this.$t("calendar.weekly"),
                    value: "weekly",
                },
                {
                    label: this.$t("calendar.monthly"),
                    value: "monthly",
                },
                {
                    label: this.$t("calendar.annually"),
                    value: "annually",
                },
                {
                    label: this.$t("calendar.custom"),
                    value: "custom",
                },
            ],
            visibilities: [
                {
                    label: "Public",
                    value: "public",
                },
                {
                    label: "Private",
                    value: "private",
                },
            ],
            cloneCalendarList: [],
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
        }),
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({
            getCalendarList: "calendar/getCalendarList",
            updateCalendarEvent: "calendar/updateCalendarEvent",
        }),
        ...mapMutations({}),
        deleteEvent(e) {
            console.log("deleteEvent event", e);
            const data = {
                userId: this.user._id,
                eventId: this.eventDetail._id,
                deleteType: e.selectDeleteType || "single",
            };
            CALENDAR_API.deleteCalendarEvent(data).then((res) => {
                this.$emit("deleteEvent", { eventId: data.eventId, deleteType: data.deleteType });
                this.$emit("close");
            });
        },
        async editOrCreateEvent(data) {
            console.log("editOrCreateEvent data", data);
            if (data.isEdit) {
                const event = await this.updateCalendarEvent({ eventId: data.eventId, data });
                sendSocketMessage("calendar update-event", {
                    siteId: this.site._id,
                    event,
                });
                this.$emit("editEvent", data);
            } else {
                const events = await CALENDAR_API.createCalendarEvent(data);
                console.log("created events....", { events: events.data });
                sendSocketMessage("calendar create-event", {
                    siteId: this.site._id,
                    events: events.data,
                });
            }
            this.$message.warning(this.$t("calendar.custom"), 3);
            this.$emit("close");
        },
        changeSelectedTag(tag) {
            this.selectedTag = tag;
        },
    },
    async mounted() {
        this.cloneCalendarList = await this.getCalendarList({ userId: this.user._id, userName: this.user.name });
    },
    watch: {},
};
</script>

<style lang="scss" scoped>
#create-event-form {
    .event-input {
        width: 100%;
        border: none;
        border-bottom: 0.5px solid grey;
        margin-bottom: 10px;
        height: 30px;
        margin-top: 10px;

        &:hover {
            border-bottom: 1px solid #021eb6;
        }
    }

    .tags {
        display: flex;
        align-items: center;

        .tag {
            color: rgb(109, 117, 131);
            padding: 5px;
            border-radius: 5px;
            font-size: 12px;
            font-weight: 500;
            margin-right: 10px;
            cursor: pointer;

            &:hover {
                background-color: #e8e8e8;
            }

            &.selected {
                background-color: rgb(210, 227, 252);
                color: rgb(66, 133, 244);
            }
        }
    }

    .single {
        margin-right: 5px;
    }

    .info {
        margin-top: 15px;
        display: flex;
        align-items: center;
    }

    .attachments {
        .attachment {
            margin-bottom: 5px;
            background-color: aliceblue;
            padding: 3px;
            border-radius: 5px;
        }
    }

    .description {
        margin-left: 10px;
    }

    .attach-icon {
        font-size: 20px;
    }

    .attachment {
        display: flex;
        align-items: center;
    }

    .lock-icon {
        font-size: 20px;
        margin-right: 10px;
    }

    .attache_file_btn {
        border: none;
        padding: 5px;
        border-radius: 5px;
        background-color: white;

        &:hover {
            background-color: #e8e8e8 !important;
        }
    }
}
</style>
